import React from 'react';
import PropTypes from 'prop-types';

export default function DateSelector({ selectedDate, onDateSelect }) {
  // Generate dates for the next 2 weeks
  const generateDates = () => {
    const dates = [];
    const today = new Date();
    const twoWeeks = 14; // 2 weeks

    for (let i = 0; i < twoWeeks; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() + i);
      dates.push(date);
    }

    // Split into two weeks
    return [
      dates.slice(0, 7),  // First week
      dates.slice(7, 14)  // Second week
    ];
  };

  const weeks = generateDates();
  const formatDate = (date) => {
    return {
      day: date.toLocaleDateString('en-US', { weekday: 'short' }),
      date: date.getDate(),
      month: date.toLocaleDateString('en-US', { month: 'short' }),
      fullDate: date.toISOString().split('T')[0]
    };
  };

  const isSameDate = (date1, date2) => {
    if (!date1 || !date2) return false;
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    return d1.getFullYear() === d2.getFullYear() &&
           d1.getMonth() === d2.getMonth() &&
           d1.getDate() === d2.getDate();
  };

  const isToday = (date) => {
    const today = new Date();
    return isSameDate(date, today);
  };

  return (
    <div className="space-y-2">
      {/* Date selection container */}
      <div className="space-y-2">
        {weeks.map((week, weekIndex) => (
          <div
            key={weekIndex}
            className="grid grid-cols-7 gap-1"
          >
            {week.map((date) => {
              const formattedDate = formatDate(date);
              const isSelected = isSameDate(selectedDate, formattedDate.fullDate);
              const isTodayDate = isToday(date);

              return (
                <button
                  key={formattedDate.fullDate}
                  onClick={() => onDateSelect(formattedDate.fullDate)}
                  className={`p-1 rounded-lg text-center transition-all transform
                    ${isSelected 
                      ? 'bg-blue-500 text-white' 
                      : 'bg-white hover:bg-blue-50'
                    } ${isTodayDate ? 'ring-1 ring-blue-500' : 'border border-gray-200'}
                  `}
                >
                  <div className="text-[10px] font-medium">{formattedDate.day}</div>
                  <div className="text-sm font-bold">{formattedDate.date}</div>
                  <div className="text-[10px]">{formattedDate.month}</div>
                </button>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
}

DateSelector.propTypes = {
  selectedDate: PropTypes.string,
  onDateSelect: PropTypes.func.isRequired
};

// Add custom styles to hide scrollbar but keep functionality
const styles = `
  .hide-scrollbar {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  .hide-scrollbar::-webkit-scrollbar {
    display: none;
  }
`;

const styleSheet = document.createElement("style");
styleSheet.innerText = styles;
document.head.appendChild(styleSheet); 